import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ImageUrl, Listing, ListingSchema, ServiceMenu, } from "@lumora/core";
import { useMemo } from "react";
import { ListingDetailModal } from "../../listings/ListingDetailModal.js";
import { useViewModel } from "../../react/useViewModel.js";
import { BookToggleButton } from "./BookToggleButton.js";
import { useCheckoutMorph } from "./useCheckoutMorph.js";
/** Single-column popup: photo, name, price, description. No custom-field tiles. */
const SERVICE_SCHEMA = new ListingSchema([]);
function toListing(item) {
    const id = ServiceMenu.serviceId(item);
    return Listing.fromData({
        id,
        title: item.name,
        description: item.summary,
        priceLabel: item.priceLabel,
        ...(ImageUrl.has(item.imageUrl) ? { imageUrl: ImageUrl.usable(item.imageUrl) } : {}),
    }, id);
}
/**
 * Detail popup for one service: the shared `ListingDetailModal`. Book toggles the service; once
 * something is booked, Checkout fades the popup out and opens the booking form with the
 * center-then-settle morph (see core `CheckoutMorph`).
 */
export function ServiceDetail({ item, cart, config, router, onClose, }) {
    useViewModel(cart);
    const navigate = router.useNavigate();
    const morph = useCheckoutMorph({ navigate, to: config.cart.routes.book, onDone: onClose });
    const id = ServiceMenu.serviceId(item);
    const listing = useMemo(() => toListing(item), [item]);
    const { popup } = config;
    const actions = (_jsxs("div", { className: "lu-service-detail-actions cd-service-detail-actions", children: [_jsx(BookToggleButton, { serviceName: item.name, booked: cart.has(id), onToggle: (action) => cart.toggleService({ id, name: item.name, priceLabel: item.priceLabel }, action), className: "cd-btn-gold", labels: config.cart.toggle }), cart.state.count > 0 ? (_jsx("button", { type: "button", className: "cd-btn-gold cd-service-checkout", "data-service-detail-checkout": "true", disabled: morph.busy, onClick: morph.start, children: popup.checkoutLabel })) : null] }));
    return (_jsx("div", { className: "lu-featured cd-featured lu-service-detail cd-service-detail", "data-morph-phase": morph.phase, style: morph.style, children: _jsx(ListingDetailModal, { listing: listing, schema: SERVICE_SCHEMA, onClose: onClose, layout: popup.layout, primaryAction: actions, headingLevel: popup.headingLevel, priceLabel: popup.priceLabel, descriptionLabel: popup.descriptionLabel }) }));
}
//# sourceMappingURL=ServiceDetail.js.map